module.exports = __webpack_public_path__ + "img/1fAM7tyxfBMMSkBW9VW7z9J5DdCAD2geR.d6c01b39.png";